    <div class="mt-3 text-sm p-2 surface-0">
  <div class="surface-0">
      <!-- Header -->
      <div class="py-2 px-3 border-bottom-1 border-300 flex align-items-center justify-content-between">
          <strong>{{'SUBSCRIPTIONS.PAYMENT-TIMELINE' | translate}}</strong>
          <p-button (click)="ShowTimelineData()" styleClass="p-button-outlined text-xs" [label]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.VIEW_FULL_TIMELINE' | translate" icon="fa fa-timeline"></p-button>
      </div>
      <!-- Header -->
      <!-- Content -->
      <div class="pl-5 pr-1 pb-3 overflow-x-auto overflow-y-hidden">
          <p-timeline [value]="filtetredTimelineData$.value" layout="horizontal" styleClass="mt-2 md:ml-4 -mb-3 white-space-nowrap">
              <ng-template pTemplate="marker" let-timeline>
                  <span
                      *ngIf="timeline.payment_status && isSuccessfulPayment(timeline)"
                      class="custom-marker h-2rem w-full max-w-2rem border-circle p-button p-0 bg-green-500 flex align-items-center justify-content-center">
                      <i *ngIf="shouldShowIcon(timeline)"
                          [pTooltip]="getTooltipMessage(timeline)" 
                          tooltipStyleClass="text-xs"
                          class="fa fa-exclamation-triangle text-white">
                        </i>
                  </span>
                  <span *ngIf="(timeline.payment_status === paymentStatus.None || timeline.payment_status.toString() === paymentStatus[paymentStatus.None])
                    || (timeline.payment_status === paymentStatus.Initiated|| timeline.payment_status.toString() === paymentStatus[paymentStatus.Initiated])" 
                        class="custom-marker h-2rem w-full max-w-2rem border-circle border-2 border-400 flex align-items-center justify-content-center">
                    <i *ngIf="shouldShowIcon(timeline)"
                    [pTooltip]="getTooltipMessage(timeline)" 
                    tooltipStyleClass="text-xs"
                    class="fa fa-exclamation-triangle">
                  </i>
                </span>
                  <span *ngIf="timeline.payment_status && isfailedPayment(timeline)"
                      class="custom-marker h-2rem w-full max-w-2rem border-circle p-button p-button-danger p-0 flex align-items-center justify-content-center">
                      <!-- <i *ngIf="isInitialFailedPayment(timeline)" 
                         [pTooltip]="getTooltipMessage(timeline)" 
                         tooltipStyleClass="text-xs" 
                         class="fa fa-exclamation-triangle text-white">
                      </i> -->
                      <i  
                        [pTooltip]="'Failed due to : '+ timeline.failed_reason" 
                        tooltipStyleClass="text-xs" 
                         class="fa fa-exclamation-triangle text-white">
                      </i>
                  </span>
              </ng-template>

              <ng-template pTemplate="content" let-timeline>
                  <div class="w-7rem md:w-5rem text-left">
                      <div *ngIf="timeline.payment_status && (timeline.payment_status === paymentStatus.None || timeline.payment_status.toString() === paymentStatus[paymentStatus.None])" class="text-sm white-space-nowrap text-700 -mt-1 -ml-2">{{ timeline.occurance_invoice_id > 0 ? ( timeline.payment_amount_in_minor_currency | currencyformat ) : timeline.invoice_amount_in_minor_currency | currencyformat }}</div>
                      <div *ngIf="timeline.payment_status && (timeline.payment_status === paymentStatus.Initiated || timeline.payment_status.toString() === paymentStatus[paymentStatus.Initiated])" class="text-sm white-space-nowrap text-700 -mt-1 -ml-2">{{ timeline.occurance_invoice_id > 0 ? ( timeline.payment_amount_in_minor_currency | currencyformat ) : timeline.invoice_amount_in_minor_currency | currencyformat }}</div>
                      <strong *ngIf="timeline.payment_status && (timeline.payment_status === paymentStatus.Successfull || timeline.payment_status.toString() === paymentStatus[paymentStatus.Successfull])" class="text-sm white-space-nowrap block -mt-1 -ml-2">
                          {{ timeline.occurance_invoice_id > 0 ? (timeline.payment_amount_in_minor_currency | currencyformat) : timeline.invoice_amount_in_minor_currency | currencyformat | currencyformat}}
                      </strong>
                      <strong *ngIf="timeline.payment_status && (timeline.payment_status === paymentStatus.Failed || timeline.payment_status.toString() === paymentStatus[paymentStatus.Failed])" class="text-sm white-space-nowrap p-error block -mt-1 -ml-3">
                          {{ timeline.occurance_invoice_id > 0 ? (timeline.payment_amount_in_minor_currency | currencyformat): timeline.invoice_amount_in_minor_currency | currencyformat }}
                      </strong>
                      <div class="h-2rem -ml-2">
                          <div *ngIf="(timeline.payment_status === paymentStatus.None || timeline.payment_status.toString() === paymentStatus[paymentStatus.None])
                            || (timeline.payment_status === paymentStatus.Initiated || timeline.payment_status.toString() === paymentStatus[paymentStatus.Initiated])">
                              <p-tag
                                    *ngIf="(timeline.occurance_type === recurringOccuranceType.Deposit || timeline.occurance_type.toString() === recurringOccuranceType[recurringOccuranceType.Deposit])
                                    && shouldDisplayDepositTag(timeline, filtetredTimelineData$.value)"
                                    severity="success"
                                    [value]="'DEPOSIT.DEPOSIT' | translate"
                                    styleClass="text-xxs"
                                    tooltipStyleClass="text-xs">
                              </p-tag>
                              <br>
                              <p-tag
                                *ngIf="(timeline.occurance_type === recurringOccuranceType.Deposit || timeline.occurance_type.toString() === recurringOccuranceType[recurringOccuranceType.Deposit])
                                && shouldDisplayDepositTag(timeline, filtetredTimelineData$.value)"
                                [severity]="timeline.deposit_applied ? 'success' :'secondary'"
                                [value]="timeline.deposit_applied ? ('DEPOSIT.DEPOSIT_STATUS_APPL' | translate) : ('DEPOSIT.DEPOSIT_STATUS_SCHED' | translate)"
                                styleClass="text-xxs"
                                [ngClass]="{'py-0 surface-0 border-1 border-400 text-600': !timeline.deposit_applied}"
                                tooltipStyleClass="text-xs">
                             </p-tag>
                          </div>
                          <div *ngIf="timeline.payment_status !== paymentStatus.None && timeline.payment_status.toString() !== paymentStatus[paymentStatus.None]">
                              <p-tag
                                *ngIf="(timeline.occurance_type === recurringOccuranceType.Deposit || timeline.occurance_type.toString() === recurringOccuranceType[recurringOccuranceType.Deposit])
                                && shouldDisplayDepositTag(timeline, filtetredTimelineData$.value)"
                                severity="success"
                                [value]="'DEPOSIT.DEPOSIT' | translate"
                                styleClass="text-xxs py-0"
                                [pTooltip]="getTooltipMessage(timeline)" 
                                tooltipStyleClass="text-xs">
                              </p-tag>
                              <br>
                              <p-tag
                                *ngIf="(timeline.occurance_type === recurringOccuranceType.Deposit || timeline.occurance_type.toString() === recurringOccuranceType[recurringOccuranceType.Deposit])
                                && shouldDisplayDepositTag(timeline, filtetredTimelineData$.value)"
                                [severity]=" timeline.deposit_applied ? 'success' :''"
                                [value]=" timeline.deposit_applied ? ('DEPOSIT.DEPOSIT_STATUS_APPL' | translate) : ('DEPOSIT.DEPOSIT_STATUS_SCHED' | translate)"
                                styleClass="text-xxs py-0 surface-0 border-1 border-400 text-600"
                                tooltipStyleClass="text-xs">
                              </p-tag>
                          </div>
                          <span *ngIf="isFailedPaymentWithRecurring(timeline)" (click)="callRetryPayment(timeline)" class="p-error text-xs cursor-pointer -ml-5 flex align-items-center"><i class="text-xs mr-1" [ngClass]="isbuttonclicked ? 'fa fa-spinner': 'fa fa-rotate-right' "></i><span class="underline">{{ 'DEPOSIT.RETRY_PAYMENT' | translate }}</span></span>
                      </div>
                     
                  </div>
              </ng-template>
              <ng-template pTemplate="opposite" let-timeline let-i="index">
                  <div class="w-7rem md:w-5rem text-left">
                      <span *ngIf="(timeline === filtetredTimelineData$.value[filtetredTimelineData$.value.length - 1]) && (subscription.subscription_category === 'PayAsYouGo' || subscription.subscription_category === '1'); else showDate"
                          class="block text-xxs md:text-xs white-space-nowrap text-600 -mt-2 text-left">
                          <i class="fa-solid fa-infinity text-primary text-2xl"></i>
                      </span>
                      <ng-template #showDate>
                          <span class="block text-xxs md:text-xs white-space-nowrap -mt-2 -ml-3 text-left">
                              {{timeline.occurance_start_date | date:'dd MMM yyyy'}}
                          </span>
                      </ng-template>
                  </div>
              </ng-template>
          </p-timeline>
      </div>
      <!-- Content -->
  </div>
</div>

<!-- Payment Timeline Modal  -->
<p-dialog [(visible)]="paymentTimelineModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '800px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div class="surface-0 sticky left-0 bottom-0 w-full z-1 border-bottom-1 border-300 p-3 flex align-items-center justify-content-between">
          <h2 class="mb-0 text-sm line-height-1">{{'SUBSCRIPTIONS.PAYMENT_TIMELINE.HEADER' | translate}}</h2>
          <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="paymentTimelineModal = false"></div>
      </div>
      <!-- Header -->
      <!-- Content -->
      <app-data-grid
          [columnData]="timelineData$"
          [columns]="timelineDataTablecolumns$"
          [selectable]="selecall"
          tableClasses="shadow-2 p-0 my-3"
          [headerClasses]="'surface-100 text-xs text-600'"
          [paginator]="false"
          [EmptyState]="emptyStateComponentForHistory$"
          (onAction)="onActionEvent($event)"
          [gridName]="'payment-timeline-list'">
      </app-data-grid>
      <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Payment Timeline Modal -->
